import BaseSettingsPage from "@settings/base/BaseSettingsPage";


export const ProjectSettingsPage = () => {
  return <BaseSettingsPage title="Meine Projekte" />
}